import { useContext } from 'react'

import { conversionKeysToBlacklistKeys } from '../../../../../main/blacklistHelpers'
import { popularEmailProviders } from '../../../../../main/commonStatic'
import Column from '../../../Column/index'
import BlacklistContext from '../../BlackListContext'
import CheckRow, { CheckTextRow } from '../../CheckRow/index'

const blacklistables = {
  invited: ['invitedFormattedAddress', 'invitedPhoneNumber', 'invitedEmail'],
  converted: ['convertedFormattedAddress', 'convertedPhoneNumber', 'convertedEmail'],
  trackingAndRate: ['convertedTrackingCode', 'convertedRateCode']
}

const Details = () => (
  <>
    <InvitedColumn />
    <ConvertedColumn />
    <RateTrackingColumn />
  </>
)

const InvitedColumn = () => <InvitedConvertedColumn type="invited" />

const ConvertedColumn = () => <InvitedConvertedColumn type="converted" />

const RateTrackingColumn = () => {
  const {
    values,
    setValue,
    setLength,
    conversion: { convertedRateCode, convertedTrackingCode }
  } = useContext(BlacklistContext)

  return (
    <Column title="Rate &amp; tracking code">
      <CheckRow
        name="rateCodeFull"
        value={`${convertedRateCode} rate code`}
        setValue={setValue}
        checked={values.rateCodeFull}
      />
      <CheckTextRow
        name="rateCodeStartsWith"
        title="Rate code starts with"
        defaultVal={convertedRateCode}
        setValue={setValue}
        setLength={setLength}
        checked={values.rateCodeStartsWith}
      />
      <CheckRow
        name="trackingInfoFull"
        value={`${convertedTrackingCode} tracking code`}
        setValue={setValue}
        checked={values.trackingInfoFull}
      />
      <CheckTextRow
        name="trackingInfoStartingWith"
        title="Tracking code starts with"
        defaultVal={convertedTrackingCode}
        setValue={setValue}
        setLength={setLength}
        checked={values.trackingInfoStartingWith}
      />
    </Column>
  )
}

const InvitedConvertedColumn = ({ type }) => {
  const { values, setValue, conversion } = useContext(BlacklistContext)

  let email = conversion[type === 'invited' ? 'invitedEmail' : 'convertedEmail']
  const domain = email && email.match(/@.+/) ? email.match(/@.+/)[0].toLowerCase() : null

  return (
    <Column title={type === 'invited' ? 'Invited' : 'Converted'}>
      {blacklistables[type].map(
        d =>
          isConversationValValid(conversion, d) && (
            <CheckRow
              setValue={setValue}
              name={conversionKeysToBlacklistKeys[d]}
              value={conversion[d]}
              key={d}
              checked={values[conversionKeysToBlacklistKeys[d]]}
            />
          )
      )}
      {domain && !popularEmailProviders.includes(domain.replace('@', '')) && (
        <CheckRow
          setValue={setValue}
          value={domain}
          name={type === 'invited' ? 'invitedEmailDomain' : 'convertedEmailDomain'}
          checked={
            type === 'invited' ? values.invitedEmailDomain : values.convertedEmailDomain
          }
        />
      )}
    </Column>
  )
}

function isConversationValValid(conversation, d) {
  if (d.includes('Email')) {
    return conversation[d] && conversation[d].match(/@.+/)
  }

  return conversation[d]
}

export default Details
